import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
  root: {
    '&.MuiDataGrid-root .MuiDataGrid-cell, &.MuiDataGrid-root .MuiDataGrid-columnHeader': {
      '&:focus, &:focus-within': {
        outline: 'none',
      },
    },
  },
  button: { marginBottom: '10px' },
  container: {
    padding: '5%',
    flexGrow: 1,
  },
  title: {
    fontWeight: 600,
    flex: 2,
  },
  routeIconContainer: {
    verticalAlign: 'middle',
    cursor: 'pointer',
  },
  link: {
    cursor: 'pointer',
  },
  header: {
    marginRight: '10px',
  },
  actionButton: {
    marginTop: '3px',
    padding: '2px 10px',
  },
  actionTypography: {
    marginTop: '10px',
  },
  actionBox: {
    display: 'flex',
    alignItems: 'flex-end',
  },
  flexBox: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
}));
